import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import Loading from 'src/components/Loading';
import { DateTime } from 'src_common/utils/time/time';
import { AffordabilityAuditTable } from './AuditAffordability.style';
import { AuditPanelWrapper } from 'src/components/ComplianceAudits/AuditPanel.style';
import { AuditHeader } from 'src/components/ComplianceAudits/AuditHeader';
import { AuditAffordabilityState } from 'src/components/AuditAffordability/AuditAffordability.state';

export const AffordabilityAuditContent = observer('AffordabilityAuditContent', () => {
    const { sdkStaff, routerBackoffice } = useAppStateContext();
    const [state] = useState(() => new AuditAffordabilityState(sdkStaff, routerBackoffice));

    return (
        <AuditPanelWrapper>
            <AuditHeader
                title='Affordability audit'
                from={state.from}
                to={state.to}
                onChangeFrom={state.handleChangeFromDate}
                onChangeTo={state.handleChangetoDate}
            />

            <Loading
                message='Loading audits...'
                active={state.status === 'loading'}
            />

            {state.status === 'error' ? (
                <div>Error was occured</div>
            ) : (
                <div className='flex-1 min-h-0 overflow-auto'>
                    <AffordabilityAuditTable>
                        <thead>
                            <tr>
                                <th>Check Date</th>
                                <th>Check Color</th>
                                <th>Check Trigger</th>
                                <th>Reason</th>
                                <th>Reviewed</th>
                                <th>Review Date</th>
                                <th>Reviewer Id</th>
                                <th>Reviewer Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.status === 'noData' ? (
                                <tr>
                                    <th>No results found, try to change time limits</th>
                                </tr>
                            ) : (
                                state.auditData.map((item) => (
                                    <tr key={item.checkDate}>
                                        <th>
                                            {DateTime.from(item.checkDate)
                                                ?.subtractHours(2)
                                                .format('YYYY-MM-DD HH:mm:ss')}
                                        </th>
                                        <th>{item.affordabilityColor}</th>
                                        <th>{item.checkTrigger}</th>
                                        <th>{item.reason}</th>
                                        <th>{item.reviewed !== null && item.reviewed?.toString()}</th>
                                        <th>
                                            {item.reviewDate !== null &&
                                                DateTime.from(item.reviewDate)
                                                    ?.subtractHours(2)
                                                    .format('YYYY-MM-DD HH:mm:ss')}
                                        </th>
                                        <th>{item.reviewerId}</th>
                                        <th>{item.reviewerName}</th>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </AffordabilityAuditTable>
                </div>
            )}
        </AuditPanelWrapper>
    );
});
